define.alias("shared/components/shared/social-identity/item", "media/components/shared/social-identity/item");